/* @flow */

import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import dynamic from 'next/dynamic';
import is from 'is_js';
import {
  Tooltip,
  // $FlowFixMe
} from '@bijie/react-bnb';
import moment from 'moment';
import Icon from '../Icon';
import EmptyTable, { ImageBox } from '../EmptyTable';
import { Container } from '../Container';
import { getLabel } from '../../utils/i18n';
import { fetchAllAssetsLogo } from '../../actions/actionsSet/asset';
import { fetchVipInterest, fetchVipInterestAdj, fetchMarginFeeMaxBorrow } from '../../actions/actionsSet/margin';
import {
  bigNumberMultiply, formatBigNumber, formatNumber, pencentage,
} from '../../utils/number';
import FlexBox from '../FlexBox';
import TrackVisibility from '../TrackVisibility';

const PriceIndexHistory = dynamic(import('./PriceIndexHistory'), {
  ssr: false,
  loading: () => null,
});

const filterAssetDataSource = (logoMap: Object, assets: Array<Object> = []) => assets.map(asset => ({
  ...asset,
  logoUrl: logoMap[asset.assetName],
}));


const getInterest = (dailyInterest: string) => {
  if (!dailyInterest) return '';
  // eslint-disable-next-line
  return `${formatBigNumber(bigNumberMultiply(dailyInterest, '100'), 6)}% / ${formatBigNumber(bigNumberMultiply(bigNumberMultiply(dailyInterest, '365'), '100'), 2)}%`;
};


const StickyHeader = styled.div`
    position: sticky;
    top: 60px;
    z-index: 1;
    background: white;
    padding: 40px 0 32px 0;
`;

const Title = styled.div`
  padding: 16px 0 16px 0;
  font-family: ${({ theme }) => theme.fontIBMRegular};
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 23px;
  color: #212833;
  display: flex;
  justify-content: space-between;
`;

const VIPTitle = styled.div`
  font-family: ${({ theme }) => theme.fontIBMBold};
  font-weight: 600;
`;

const HeaderLink = styled.a`
  font-family: ${({ theme }) => theme.fontIBMMedium};
  font-style: normal;
  font-weight: 550;
  font-size: 14px;
  line-height: 18px;
  color: ${({ active }) => active ? '#212833' : '#848E9C'};
  padding: ${({ padding }) => padding};
  border: ${({ border }) => border};
  border-right: ${({ borderRight }) => borderRight};
  border-left: ${({ borderLeft }) => borderLeft};
`;

const TitleWrap = styled.div`
  display: flex;
  flex: 1;
  line-height: 22px;
  color: #212833;
  .shortname {
    display: inline-block;
    padding-left: 10px;
    vertical-align: middle;
    word-break: normal;
  }
`;
const Wrapper = styled.div`
  .sub-content {
    &:nth-child(2) {
    padding-top: 0px !important;
    }
    padding-top: 32px;
    padding-bottom: 16px;
    background: #fff;
    &.last {
      margin-bottom: 0;
      padding-bottom: 140px;
      .icon-prompt {
        vertical-align: middle;
      }
    }
  }
  .banner {
    position: relative;
    img {
      width: 100%;
      object-fit: none;
    }
  }
  .banner-title {
    position: absolute;
    top: 18%;
    width: 100%;
    margin-bottom: 0;
    text-align: center;
    color: #fff;
    line-height: 104px;
    font-size: 80px;
    font-weight: 200;
    font-family: ${({ theme }) => theme.fontIBMExtraLight};
  }
  .circle-icon {
    position: relative;
    display: inline-block;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: rgba(0,192,135,.15);
    &::before {
      content: ' ';
      position: absolute;
      width: 22px;
      height: 22px;
      background: url(${require('../../static/images/margin/icon_yes.svg')}) no-repeat center center;
    }
    &.not {
      &:before {
        background: url(${require('../../static/images/margin/icon_no.svg')}) no-repeat center center;
      }
      background: rgba(242, 48, 81, .15);
    }
  }

  .userfee {
    th:not(:last-child) {
      border-right: 1px solid #EAECEF;
    }
    td:nth-child(odd):not(:last-child) {
      border-right: 1px solid #EAECEF;
    }
  }

  th.actived {
    color: #212833;
    background: rgba(240, 185, 11, 0.1);
  }
  td.actived {
    color: #212833;
    background: rgba(240, 185, 11, 0.1);
    border-bottom: 1px solid #EAECEF;
  }

  .bnc-table-expanded-row {
      box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.06);
   }

  tr {
    th {
      &:first-child {
      border-radius: 3px 0  0 0;
      }
      &:last-child {
      border-radius: 0 3px  0 0;
      }
    }
      &:hover {
      td {
       &.actived {
          background-color: rgba(240, 185, 11, .3) !important
          }
        }
      }
  }

  tr.bnc-table-expanded-row:hover {
    background: white !important
  }

  .bnc-table-expanded-row {
    td {
    padding: 0 !important
   }
  }

  .margin-asset{
    th.actived {
     &:nth-child(odd) {
     border-left: 1px solid rgba(240, 185, 11, .3);
    }
    &:nth-child(even) {
    border-right: 1px solid rgba(240, 185, 11, .3);
    }
  }
   td.actived {
      &:nth-child(odd) {
     border-left: 1px solid rgba(240, 185, 11, .3);
    }
    &:nth-child(even) {
    border-right: 1px solid rgba(240, 185, 11, .3);
    }
   }
  }
`;

const TooltipBox = styled.span`
  margin-left: 6px;
  cursor: pointer;
  .icon-prompt {
    &:hover { color: #f0b90b; }
  }
`;
const TooltipInner = styled.div`
  max-width: 400px;
  a {
    color: #f0b90b;
    &:hover {text-decoration-line: underline}
  }
`;

const MarginFeeTitle = styled.div`
  font-family: IBM Plex Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 34px;
  line-height: 44px;
  color: #212833;
`;

const NoticeContainer = styled(Container)`
  padding: 17px 32px;
  background: #FFFFFF;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.06);
  border-radius: 3px;
`;

const NoticeBar = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 297px;
  height: 32px;
  background: #F0B90B;
  border-radius: 16.5px;
`;

const InterestDate = styled.div`
  padding: 12px;
  font-family: DIN Pro;
  font-size: 16px;
  line-height: 21px;
  color: #212833;
`;

const NoticeBarText = styled.div`
  margin-left: 8px;
  font-family: IBM Plex Sans;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 23px;
`;

const ExpandText = styled.div`
  cursor: pointer;
  margin: auto;
  margin-top: 17px;
  font-family: IBM Plex Sans;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: #F0B90B;
`;

const MarginablePair = styled.div`
  margin-top : 8px;
  margin-right: 30px;
  padding: 4px;
`;

const MarginPairHeader = styled.div`
  display: inline-block;
  padding: 12px;
  width: 150px;
  height: 100%;
`;
const MarginPairContent = styled.div`
  display: flex;
  flex: 1;
  flex-wrap: wrap;
`;

const ScaleDown = styled.div`
   transform: scale(.7);
`;

const Tip = styled.span`
  font-size: 12px;
`;

export const TitleWithTooltip = ({ tooltipLabel, i18n }: Object) => (
  <TooltipBox>
    <Tooltip
      placement="top"
      trigger={['hover']}
      overlay={
        <TooltipInner
          dangerouslySetInnerHTML={{ __html: `${getLabel(tooltipLabel, i18n)}` }}
        />
      }
    >
      <Icon type="prompt" size={14} color="#48515D" />
    </Tooltip>
  </TooltipBox>
);

const getMarginInterestAdjColumn = (i18n, tradeLevel) => {
  const base = [
    {
      title: getLabel('exchange-common-coin', i18n),
      dataIndex: '',
      key: 'coin',
      render: (value: Object, { logoUrl, assetName }: Object) => (
        <TitleWrap>
          <ImageBox size="26">
            <img src={logoUrl} alt="" />
          </ImageBox>
          <span className="shortname">{assetName}</span>
        </TitleWrap>
      ),
    },
    {
      title: getLabel('exchange-common-direction', i18n),
      dataIndex: 'direction',
      key: 'direction',
    },

  ];

  const other = tradeLevel === 0 ? [
    {
      title: (
        <TitleWrap>
          <FlexBox direction="column" align="center">
            <VIPTitle>{getLabel('exchange-common-yourLevel', i18n, 'Your Level')}: VIP {tradeLevel}</VIPTitle>
            <div>{getLabel('exchange-common-dailyInterestRateAdjustment', i18n)}</div>
          </FlexBox>
        </TitleWrap>),
      dataIndex: `${tradeLevel}_rate`,
      key: `${tradeLevel}_rate`,
      className: 'actived',
      align: 'center',
      width: 340,
    },
  ] : [{
    title: (
      <FlexBox direction="column" align="center">
        <VIPTitle>VIP 0</VIPTitle>
        <div>{getLabel('exchange-common-dailyInterestRateAdjustment', i18n)}</div>
      </FlexBox>),
    dataIndex: '0_rate',
    key: '0_rate',
    align: 'center',
    width: 340,
  },
  {
    title: (
      <TitleWrap>
        <FlexBox direction="column" align="center">
          <VIPTitle>{getLabel('exchange-common-yourLevel', i18n, 'Your Level')}: VIP {tradeLevel}</VIPTitle>
          <div>{getLabel('exchange-common-dailyInterestRateAdjustment', i18n)}</div>
        </FlexBox>
      </TitleWrap>),
    dataIndex: `${tradeLevel}_rate`,
    key: `${tradeLevel}_rate`,
    className: 'actived',
    align: 'center',
    width: 340,
  },

  ];

  return base.concat(other);
};


const getAssetColumn = (i18n, tradeLevel, isLoggedIn) => {
  const base = [
    {
      title: getLabel('exchange-common-coin', i18n),
      dataIndex: '',
      key: 'coin',
      width: 130,
      render: (value: Object, { logoUrl, assetName }: Object) => (
        <TitleWrap>
          <ImageBox size="26">
            <img src={logoUrl} alt="" />
          </ImageBox>
          <span className="shortname">{assetName}</span>
        </TitleWrap>
      ),
    },
    {
      title: getLabel('exchange-marginfee-transferin', i18n),
      dataIndex: 'isMortgageable',
      key: 'isMortgageable',
      render: isMortgageable => <span className={`circle-icon ${!isMortgageable ? 'not' : ''}`} />,
    },
    {
      title: <span>{getLabel('exchange-marginfee-borrowable', i18n)}<TitleWithTooltip tooltipLabel="exchange-marginfee-borrowtip" i18n={i18n} /></span>,
      dataIndex: 'isBorrowable',
      key: 'isBorrowable',
      render: isBorrowable => <span className={`circle-icon ${!isBorrowable ? 'not' : ''}`} />,
    },
  ];

  const other = !isLoggedIn ? [
    {
      title: (
        <TitleWrap>
          <FlexBox direction="column" align="center" margin="auto">
            <VIPTitle>{getLabel('exchange-common-yourLevel', i18n)}: VIP {tradeLevel}</VIPTitle>
            <div>{getLabel('exchange-common-dailyInterestYearlyInterest', i18n)}</div>
          </FlexBox>
        </TitleWrap>
      ),
      dataIndex: `${tradeLevel}_rate`,
      key: `${tradeLevel}_rate`,
      className: `${isLoggedIn ? 'actived' : ''}`,
      align: 'center',
      width: 220,
      render: (v) => v ? `${formatBigNumber(bigNumberMultiply(v, '100'), 6)}% / ${formatBigNumber(bigNumberMultiply((v * 365).toString(), '100'), 2)}%` : '',
    },
    {
      title: (
        <TitleWrap>
          <FlexBox direction="column" align="center" margin="auto">
            <VIPTitle>{getLabel('exchange-common-yourLevel', i18n)}: VIP {tradeLevel}</VIPTitle>
            <div>{getLabel('exchange-common-borrowLimit', i18n)}</div>
          </FlexBox>
        </TitleWrap>
      ),
      dataIndex: `${tradeLevel}_borrowLimit`,
      key: `${tradeLevel}_borrowLimit`,
      className: `${isLoggedIn ? 'actived' : ''}`,
      align: 'center',
      width: 180,
      render: (v) => (
        v ? Number(v) : ''
      ),
    },
  ] : [
    {
      title: (
        <FlexBox direction="column" align="center">
          <VIPTitle>VIP 0</VIPTitle>
          <div>{getLabel('exchange-common-dailyInterestYearlyInterest', i18n)}</div>
        </FlexBox>),
      dataIndex: 'vip0InterestRate',
      key: 'vip0InterestRate',
      align: 'center',
      width: 220,
    },
    {
      title: (
        <FlexBox direction="column" align="center">
          <VIPTitle> VIP 0</VIPTitle>
          <div>{getLabel('exchange-common-borrowLimit', i18n)}</div>
        </FlexBox>),
      dataIndex: 'vip0BorrowLimit',
      key: 'vip0BorrowLimit',
      align: 'center',
      width: 180,
      render: v => (
        v ? Number(v) : ''
      ),
    },
    {
      title: (
        <TitleWrap>
          <FlexBox direction="column" align="center" margin="auto">
            <VIPTitle>{getLabel('exchange-common-yourLevel', i18n)}: VIP {tradeLevel}</VIPTitle>
            <div>{getLabel('exchange-common-dailyInterestYearlyInterest', i18n)}</div>
          </FlexBox>
        </TitleWrap>
      ),
      dataIndex: `${tradeLevel}_rate`,
      key: `${tradeLevel}_rate`,
      className: 'actived',
      align: 'center',
      width: 220,
      render: (v) => (
        getInterest(v)
      ),
    },
    {
      title: (
        <TitleWrap>
          <FlexBox direction="column" align="center" margin="auto">
            <VIPTitle>{getLabel('exchange-common-yourLevel', i18n)}: VIP {tradeLevel}</VIPTitle>
            <div>{getLabel('exchange-common-borrowLimit', i18n)}</div>
          </FlexBox>
        </TitleWrap>
      ),
      dataIndex: 'maxBorrow',
      key: `${tradeLevel}_borrowLimit`,
      className: 'actived',
      align: 'center',
      width: 180,
      render: (v) => (
        v ? Number(v) : ''
      ),
    },
  ];

  return base.concat(other);
};

const formatUserFees = (dataSource = [], logoMap) => {
  const userFeeDataSource = dataSource.map(({ assetName, specs }) => ({
    assetName,
    logoUrl: logoMap[assetName],
    ...specs.reduce((a, { vipLevel, dailyInterestRate, borrowLimit }) => {
      a[`${vipLevel}_rate`] = dailyInterestRate;
      a[`${vipLevel}_borrowLimit`] = borrowLimit;
      return a;
    }, {}),
  }
  ));
  const feeLevels = dataSource.length > 0 ? dataSource[0].specs : [];
  return {
    feeLevels,
    userFeeDataSource,
  };
};

const getUserFeeColumns = (i18n, specs = [], userLevel = -1) => {
  const columns = [
    {
      title: getLabel('exchange-common-coin', i18n),
      dataIndex: '',
      key: 'coin',
      fixed: 'left',
      width: 160,
      render: (value: Object, { logoUrl, assetName }: Object) => (
        <TitleWrap>
          <ImageBox size="26">
            <img src={logoUrl} alt="" />
          </ImageBox>
          <span className="shortname">{assetName}</span>
        </TitleWrap>
      ),
    },
  ];
  specs.forEach(({ vipLevel }) => {
    const className = +userLevel === +vipLevel ? 'actived' : '';
    columns.push({
      title: (
        <FlexBox direction="column" align="center" padding="0 30px">
          <VIPTitle>VIP {vipLevel}</VIPTitle>
          <FlexBox justify="space-between" width="100%">
            <div> {getLabel('exchange-common-interestrate', i18n)}</div>
            <div> {getLabel('exchange-marginfee-usermaxborrow', i18n)}</div>
          </FlexBox>
        </FlexBox>
      ),
      dataIndex: `${vipLevel}_rate`,
      colSpan: 2,
      width: 160,
      className,
      align: 'center',
      key: `${vipLevel}_rate`,
      render: (value: String,) => pencentage(+(value || 0), 1, {
        digit: 6,
      }),
    }, {
      title: '',
      dataIndex: `${vipLevel}_borrowLimit`,
      colSpan: 0,
      width: 160,
      className,
      align: 'right',
      key: `${vipLevel}_borrowLimit`,
      render: (value: String,) => +(value || '0'),
    });
  });
  return columns;
};

function CustomExpandIcon(props:any) {
  return (
    <a
      onClick={e => props.onExpand(props.record, e)}
      style={{ cursor: 'pointer' }}
    >
      {props.expanded ?
        <ScaleDown>
          <Icon type="arrow-u" size={12} color="#848E9C" />
        </ScaleDown>
        :
        <ScaleDown>
          <Icon type="arrow-d" size={12} color="#848E9C" />
        </ScaleDown>
        }
    </a>
  );
}

const mapStateToProps = ({
  marginAssets, marginSymbolsFlat, userInfo: { tradeLevel = -1, isSubUser = false }, isLoggedIn,
}) => ({
  marginAssets,
  marginSymbolsFlat,
  tradeLevel,
  isLoggedIn,
  isSubUser,
});

type Props = {
  i18n: Object,
  tradeLevel: Number,
  marginAssets: Array<Object>,
  marginSymbolsFlat: Array<Object>,
  fetchAllAssets: Function,
  isLoggedIn: boolean,
  isSubUser: boolean,
}
type States = {
  assetLogoMap: Object,
  vipFees: Array<Object>,
  vipFeesAdj: Array<Object>,
  expandInterestNoticerow: boolean,
  selectedLabel: string,
  marginFeeMaxBorrowList: Array<Object>
}
export default
@connect(mapStateToProps)
class MarginFee extends React.PureComponent<Props, States> {
  state = {
    assetLogoMap: {},
    vipFees: [],
    vipFeesAdj: [],
    expandInterestNoticerow: false,
    selectedLabel: '',
    marginFeeMaxBorrowList: [],
  };

  static defaultProps={
    tradeLevel: 0,
  }

  async componentDidMount() {
    fetchVipInterest().then(vipFees => {
      this.setState({
        vipFees,
      });
    });
    fetchVipInterestAdj().then(vipFeesAdj => {
      this.setState({
        vipFeesAdj,
      });
    });
    fetchAllAssetsLogo().then(assetLogoMap => {
      this.setState({
        assetLogoMap,
      });
    });
  }


  componentDidUpdate(prevProps: Props): void {
    const { tradeLevel, marginAssets, isLoggedIn } = this.props;
    if (+tradeLevel >= 1 && tradeLevel !== prevProps.tradeLevel) {
      // $FlowFixMe
      const ref = document.getElementById('borrowInterest')?.getElementsByClassName('bnc-table-body')[0];
      if (ref) {
        ref.scrollLeft = 320 * (Number(tradeLevel) - 1);
      }
    }
    if (!prevProps.isLoggedIn && isLoggedIn) {
      const allAssetsStr = marginAssets.map(i => i.assetName).join(',');
      fetchMarginFeeMaxBorrow(allAssetsStr).then(data => {
        this.setState({
          marginFeeMaxBorrowList: data.data || [],
        });
      });
    }
  }

  handleExpandInterest = (v:boolean) => {
    this.setState({ expandInterestNoticerow: v });
  };

  handleVisisble = (e:string) => {
    this.setState({ selectedLabel: e });
  }

  handleScrollToElement= (id:string) => {
    setTimeout(
      () => this.handleVisisble(id), 100
    );
    // $FlowFixMe
    const top = window.pageYOffset || document.documentElement.scrollTop;
    const element = document.getElementById(id);
    // $FlowFixMe
    const elementTop = element?.getBoundingClientRect().top;
    const gap = id === 'marginableAsset' ? 210 : 180;
    window.scroll(0, top - gap + elementTop);
  }


 _getUserFee = (assetName:string) => {
   const { vipFees, assetLogoMap } = this.state;
   const { userFeeDataSource } = formatUserFees(vipFees, assetLogoMap);
   return userFeeDataSource.filter(u => u.assetName === assetName)?.[0] || {};
 }


 render() {
   const {
     assetLogoMap, vipFees, vipFeesAdj, expandInterestNoticerow, selectedLabel,
   } = this.state;
   const {
     i18n, tradeLevel, marginAssets, marginSymbolsFlat, isLoggedIn, isSubUser,
   } = this.props;
   const filterAssets = filterAssetDataSource(assetLogoMap, marginAssets);
   const { feeLevels, userFeeDataSource } = formatUserFees(vipFees, assetLogoMap);
   const vip0FeeLevel = feeLevels[0] || {};
   const userVipFeeLevel = feeLevels.filter(v => +v.vipLevel === tradeLevel)[0] || {};
   let marginInterestAdj = [];
   let latestInterestDate = '';
   let marginAssetSource = [...filterAssets];
   if (!is.empty(vip0FeeLevel) && !is.empty(userVipFeeLevel)) {
     marginAssetSource = filterAssets.map(v => ({
       ...v,
       vip0InterestRate: getInterest(this._getUserFee(v.assetName)['0_rate']),
       vip0BorrowLimit: Number(this._getUserFee(v.assetName)['0_borrowLimit']),
       ...userFeeDataSource.filter(f => f.assetName === v.assetName)?.[0],
       ...{ maxBorrow: (this.state.marginFeeMaxBorrowList.filter(i => i.asset === v.assetName)[0]?.maxBorrow || null) },
     }));
   }

   if (vipFeesAdj.length) {
     const unixTimeNano = moment().unix() * 1000;
     const tmrUnixTimeNano = (moment().unix() + 3600 * 24 * 7) * 1000; // within one week
     const filteredVipFreesAdj = vipFeesAdj
       .filter(v => +v.effectiveTimestamp >= unixTimeNano && +v.effectiveTimestamp <= tmrUnixTimeNano);
     // eslint-disable-next-line
      const latestUnix = Math.min.apply(Math,filteredVipFreesAdj.map(v => +v.effectiveTimestamp));
     latestInterestDate = moment(latestUnix).format('YYYY-MM-DD HH:mm:ss');
     marginInterestAdj = filteredVipFreesAdj.filter(v => latestUnix === +v.effectiveTimestamp).map(v => ({
       ...v,
       ...v.specs.reduce((a, { vipLevel, currentIntRate, futureIntRate }) => {
         a[`${vipLevel}_rate`] = `${formatNumber(currentIntRate * 100, 6)}% ---> ${formatNumber(futureIntRate * 100, 6)} %`;
         return a;
       }, {}),
     }));
   }

   return (
     <Wrapper>
       <StickyHeader>
         <Container>
           <FlexBox direction="column">
             <MarginFeeTitle>
               {getLabel('exchange-common-marginData', i18n)}
             </MarginFeeTitle>
             <FlexBox margin="20px 0 0 0">
               <HeaderLink
                 onClick={() => this.handleScrollToElement('marginableAsset')}
                 active={selectedLabel === 'marginableAsset'}
                 padding="0 30px 0 0"
                 borderRight="1px solid #848E9C"
               >
                 {getLabel('exchange-common-marginableAsset', i18n)}
               </HeaderLink>
               <HeaderLink
                 onClick={() => this.handleScrollToElement('borrowInterest')}
                 active={selectedLabel === 'borrowInterest'}
                 padding="0 30px 0 30px "
               >
                 {getLabel('exchange-common-borrowInterestLimit', i18n)}
               </HeaderLink>
               <HeaderLink
                 onClick={() => this.handleScrollToElement('priceIndex')}
                 active={selectedLabel === 'priceIndex'}
                 padding="0 0 0 30px"
                 borderLeft="1px solid #848E9C"
               >
                 {getLabel('exchange-common-priceIndex', i18n)}
               </HeaderLink>
             </FlexBox>
           </FlexBox>
         </Container>
       </StickyHeader>

       {marginInterestAdj.length ?
         <div className="sub-content" id="marginableAsset">
           <NoticeContainer>
             <TrackVisibility rootMargin="-250px 0px -50px 0px" onVisible={() => this.handleVisisble('marginableAsset')}>
               <NoticeBar id="marginInterestAdj">
                 <Icon type="inmail" />
                 <NoticeBarText>
                   {getLabel('exchange-common-interestAdjustmentNotice', i18n, 'Interest Adjustment Notice')}
                 </NoticeBarText>
               </NoticeBar>
               <InterestDate>
                 {latestInterestDate}
               </InterestDate>
             </TrackVisibility>
             {expandInterestNoticerow && filterAssets.length > 3 ?
               <Fragment>
                 <EmptyTable
                   i18n={i18n}
                   data={marginInterestAdj}
                   columns={getMarginInterestAdjColumn(i18n, Number(tradeLevel))}
                   pagination={false}
                   rowKey={({ assetName }) => assetName}
                 />
                 <FlexBox onClick={() => this.handleExpandInterest(false)}>
                   <ExpandText>{getLabel('exchange-common-collapse', i18n)}&nbsp;  <Icon type="jiantoushang" size={12} /></ExpandText>
                 </FlexBox>
               </Fragment>
               :
               <Fragment>
                 <EmptyTable
                   i18n={i18n}
                   data={marginInterestAdj.slice(0, 3)}
                   columns={getMarginInterestAdjColumn(i18n, Number(tradeLevel))}
                   pagination={false}
                   rowKey={({ assetName }) => assetName}
                 />
                 {marginInterestAdj.length > 3 ?
                   <FlexBox onClick={() => this.handleExpandInterest(true)}>
                     <ExpandText>{getLabel('exchange-common-more', i18n)} &nbsp; <Icon type="jiantouxia" size={12} /></ExpandText>
                   </FlexBox>
                   : null
                }
               </Fragment>
            }
           </NoticeContainer>
         </div>
         : null}

       <div className="sub-content margin-asset">
         <Container>
           <TrackVisibility rootMargin="-250px 0px -50px 0px" onVisible={() => this.handleVisisble('marginableAsset')}>
             <Title bottom="45">
               <span>{getLabel('exchange-common-marginableAsset', i18n)}</span>
               {
                 isSubUser && (
                   <Tip>{getLabel('exchange-marginfee-marginlimit', i18n)}</Tip>
                 )
               }
             </Title>
           </TrackVisibility>
           <EmptyTable
             i18n={i18n}
             data={marginAssetSource}
             columns={getAssetColumn(i18n, Number(tradeLevel), isLoggedIn, isSubUser)}
             expandIcon={CustomExpandIcon}
             expandIconAsCell={true}
             expandRowByClick={true}
             expandedRowRender={(record, index, indent, expanded) => expanded ?
               <FlexBox>
                 <FlexBox padding="4px" direction="row" flex="1">
                   <MarginPairHeader>{getLabel('exchange-common-marginablePair', i18n)}: </MarginPairHeader>
                   <MarginPairContent>
                     {
                      // $FlowFixMe
                marginSymbolsFlat.filter(item => item?.symbol?.match(record.assetName))
                  .map(v => v.symbol)
                  .map(v => <MarginablePair>{v}</MarginablePair>)
                  }
                   </MarginPairContent>
                 </FlexBox>
                 <FlexBox width="400px" bg="rgba(240, 185, 11, .1)" />
               </FlexBox>
               : null
              }
             pagination={false}
             rowKey={({ assetName }) => assetName}
           />
         </Container>
       </div>

       <div className="sub-content userfee" id="borrowInterest">
         <Container>
           <TrackVisibility rootMargin="-250px 0px -50px 0px" onVisible={() => this.handleVisisble('borrowInterest')}>
             <Title bottom="45">{getLabel('exchange-common-borrowInterestLimit', i18n)}</Title>
           </TrackVisibility>
           <EmptyTable
             scroll={{ x: '130%' }}
             i18n={i18n}
             data={userFeeDataSource}
             columns={getUserFeeColumns(i18n, feeLevels, tradeLevel)}
             pagination={false}
             rowKey={({ assetName }) => assetName}
           />
         </Container>
       </div>

       <div className="sub-content last" id="priceIndex">
         <Container>
           <TrackVisibility rootMargin="-250px 0px -50px 0px" onVisible={() => this.handleVisisble('priceIndex')}>
             <Title bottom="45">
               {getLabel('exchange-common-priceIndex', i18n)}
               <TitleWithTooltip tooltipLabel="exchange-marginfee-pricetip" i18n={i18n} />
             </Title>
           </TrackVisibility>
           <PriceIndexHistory
             i18n={i18n}
             coinList={marginSymbolsFlat}
           />
         </Container>
       </div>
     </Wrapper>
   );
 }
}
